import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { comemosTodos26 } from "../../assets/images";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={comemosTodos26}
        alt="Comemos Todos 26"
        style={{
          maxWidth: "100%",
        }}
      />
    </Row>
  );
};

export default LoginHeader;
